export const ViewSkeletonName = 'viewSkeletonComponent';
